import { render } from "./Perks.vue?vue&type=template&id=b0ea084a&ts=true"
import script from "./Perks.vue?vue&type=script&lang=ts"
export * from "./Perks.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__